import { render, staticRenderFns } from "./Endorsement.vue?vue&type=template&id=c94aac7e&scoped=true&"
import script from "./Endorsement.vue?vue&type=script&lang=js&"
export * from "./Endorsement.vue?vue&type=script&lang=js&"
import style0 from "./Endorsement.vue?vue&type=style&index=0&id=c94aac7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94aac7e",
  null
  
)

export default component.exports